import React from 'react';

import Icon from '@components/atoms/icon';

import icon1 from '@images/clock-in-out.png';
import icon2 from '@images/write-notes.png';
import icon3 from '@images/track-breaks.png';
import icon4 from '@images/manage-overtime.png';
import icon5 from '@images/switch-between-jobs.png';
import icon6 from '@images/add-time-off.png';

import { RespondToAbsenteeism, AutomatedTimesheets } from '@components/atoms/svg-icons';

import imageOne from '@images/roofing/Respond quickly to weather changes and employee absences @2x.png';
import imageTwo from '@images/roofing/Forecast your wage bill ahead of payday to avoid unwanted surprises@2x.png';

import StopCleaners from '@images/accordion-images/Stop electricians from clocking in until they arrive on-site@2x.png';
import WorkerLocations from '@images/accordion-images/See where all your workers are in real-time@2x.png';

import CheckHowMuch from '@images/accordion-images/Keep tabs on how much work each team has done@2x.png';
import WinContracts from '@images/accordion-images/Win valuable contracts with precise cost estimates @2x.png';

import AdminAutomatedTimesheets from '@images/accordion-images/Spend less time on admin with automated timesheets@2x.png';
import GetDailySummary from '@images/accordion-images/Get a daily summary of each worker’s movements@2x.png';

export const checkList1 = [
  { title: 'Keep accurate time records while working outdoors.' },
  { title: 'Track your roofers’ time and location in real-time.' },
  { title: 'Respond quickly to changes in the weather.' },
  { title: 'Improve the accuracy of quotes to win more jobs.' },
];

export const firstList = [
  {
    title: 'Keep your staff updated and on-time',
    description: `Rosteroo keeps your staff in-the-know, all-the-time. Whenever you post a schedule, update a shift, or a shift is about to start, your staff receives instant reminder notifications.`,
    alt: 'Easy to use',
    icon: icon1,
    imageWidth: 250,
    imageHeight: 250,
  },
  {
    title: 'Find replacements without the hassle',
    description: `Make sure your business is always properly staffed. Find the right replacement, for the right shift, across all locations and job positions. Rosteroo verifies each shift replacement for you.`,
    alt: 'track breaks',
    icon: icon3,
    imageWidth: 250,
    imageHeight: 254,
  },
  {
    title: 'Instant scheduling with shift templates',
    description: `Reusable shift templates streamline your scheduling process and ensure consistency across your team. Save hours of your time and automate shift building.`,
    alt: 'Manage overtime',
    icon: icon4,
    imageWidth: 250,
    imageHeight: 254,
  },
];

export const secondList = [
  {
    title: 'Maintain accurate records of every hour on the clock',
    description: `Track regular time, overtime, paid & unpaid time off, shift notes and so much more. Use this data to increase productivity and save on payroll.`,
    alt: 'Easy to use',
    icon: icon2,
    imageWidth: 85.06,
    imageHeight: 81.81,
  },
  {
    title: 'Speed up your payroll process with timesheets on time, every time',
    description: `Get your team’s timesheet report straight to your inbox every pay period and process payroll in no time.`,
    alt: 'track breaks',
    icon: icon5,
    imageWidth: 115,
    imageHeight: 58,
  },
];

export const accordionList1 = [
  {
    icon: <RespondToAbsenteeism />,
    title: 'Respond quickly to weather changes and employee absences',
    description:
      'The unpredictability of the weather and employee absences mean you may need to change your plans at short notice. Atto allows you to instantly see which of your roofing contractors are nearby and available to work – without having to call around.',
    image: {
      src: imageOne,
      imageWidth: '369',
      imageHeight: '557',
    },
  },
  {
    icon: <Icon iconClass="named-locations" fSize="2.2" />,
    title: 'Stop roofers from clocking in until they’re ready to work',
    description:
      'When you’re reliant on paper timesheets, it’s hard to verify that your roofers are turning up to jobs on-time. With Atto, you can set the location of any job site and restrict them from clocking in until they’re physically present.',
    image: {
      src: StopCleaners,
      imageWidth: '406',
      imageHeight: '596',
    },
  },
  {
    icon: <Icon iconClass="location-tracking" fSize="2.2" />,
    title: 'Track the locations of your roofers and the progress of roofing jobs in real-time',
    description:
      'Installing solar panels, repairing leaks, fitting new roofs – when your roofing contractors are dealing with multiple jobs, it can be hard to keep track of what’s going on! With Atto, you can track the live locations of your entire workforce. Check how long your roofers have been working on each job. And, get notifications to inform you of their latest work activity.',
    image: {
      src: WorkerLocations,
      imageWidth: '418',
      imageHeight: '498',
    },
  },
  {
    icon: <Icon iconClass="movement-tracking" fSize="2.5" />,
    title: 'View a map-based timeline of your roofers’ movements',
    description:
      'Check how productive your roofing contractors are. Atto generates a map of each roofers’ daily movements, providing a clear timeline of what they were up to while working. Use it to see how long was spent at each job, along with the routing they took while on the clock.',
    image: {
      src: GetDailySummary,
      imageWidth: '399',
      imageHeight: '520',
    },
  },
];

export const accordionList2 = [
  {
    icon: <Icon iconClass="wage-estimates-bold" fSize="2.4" />,
    title: 'Forecast your wage bill ahead of payday to avoid unwanted surprises',
    description:
      'Add your roofers’ pay rates and automatically estimate their wages based on the hours they track. Now, there’ll be no more payroll surprises at the end of the week!',
    image: {
      src: imageTwo,
      imageWidth: '420',
      imageHeight: '555',
    },
  },
  {
    icon: <Icon iconClass="jobs" fSize="2.1" />,
    title: 'From roof tilers to safety inspectors see how much work each team’s completed',
    description:
      'Want to check if a job is running to budget? Need to see how much your tilers are costing you compared to your safety inspectors? In a few taps, Atto generates timesheet summaries to show all the work done on a specific job, or by a specific team.',
    image: {
      src: CheckHowMuch,
      imageWidth: '378',
      imageHeight: '492',
    },
  },
  {
    icon: <AutomatedTimesheets />,
    title: 'Reduce the admin time it takes to run your payroll',
    description:
      'To reduce admin time, Atto automatically emails you a timesheet report that coincides with your payroll period. Now all you need to do is input the data into your payroll system – saving hours from the process.',
    image: {
      src: AdminAutomatedTimesheets,
      imageWidth: '402',
      imageHeight: '589',
    },
  },
  {
    icon: <Icon iconClass="job-costing" fSize="2.2" weight="bold" />,
    title: 'Win more roofing contracts with competitive quotes',
    description:
      'Your ability to estimate your labor costs impacts whether your job quotes are profitable and competitive. With Atto, you can check the time your roofers took to complete similar jobs, and use it to produce more precise quotes in the future.',
    image: {
      src: WinContracts,
      imageWidth: '402',
      imageHeight: '589',
    },
  },
];

export const oldList = [
  'Flexible scheduling that works for you.',
  'Streamlined shift trading and cover requests for an empowered team.',
];

export const newList = [
  'Always properly staffed and ready to go.',
  'No more spreadsheets, missed shifts, or clunky communication.',
];

export const steps = [
  {
    image: '',
    title: '1. Download Atto',
    description: 'Download Atto and create an account. Available on the web, iOS and Android.',
  },
  {
    image: '',
    title: '2. Invite team members',
    description:
      'Invite your field workers, site managers, and sub-contractors via email or invite link.',
  },
  {
    image: '',
    title: '3. Ready to go!',
    description: 'Once they download Atto, you’re ready to go!',
  },
];
